<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Resources'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">
					CorDx News
				</div>
				<div class="txt" style="text-align: center;">
					For Families, For Caregivers, For YOU
				</div>
				<div class="bg_box">
					<img src="../../assets/img_h5/Resources_YD.webp" />
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="list_box">
				<div class="title"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>Latest from our blog</div>
				<div class="tags"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div :class="jqStatus == '' ? 'actived' : ''" @click="isClickHandle('')">All</div>
					<div :class="jqStatus == 2 ? 'actived' : ''" @click="isClickHandle(2)">Articles</div>
				</div>
				<div v-if="jqNewsData.length > 0" v-loading="jqNewsLoading" class="list_box_1">
					<div v-for="(value, index) in jqNewsData" :key="index" class="list_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goResourcesInfo(value)"
					>
						<img class="bg" :src="value.image" />
						<div class="txt_box">
							<div class="tit">{{ value.title }}</div>
							<div class="time">{{ value.fabu_time }}</div>
						</div>
					</div>
				</div>
				<div class="btn_box_f"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div v-if="isJqAll" class="btn_box_ty btn_box" @click="jqLoadAll">
						Load More
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块2-->
			<div class="list_box">
				<div class="title"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>Press releases</div>
				<div class="tags"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="actived">All</div>
				</div>
				<div v-if="wqNewsData.length > 0" v-loading="wqNewsLoading" class="list_box_2">
					<div v-for="(value, index) in wqNewsData" :key="index" class="list_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goResourcesInfo(value)"
					>
						<div class="left">
							<div class="time">{{ value.fabu_time }}</div>
							<div class="tit">{{ value.title }}</div>
						</div>
						<div class="right">
							<img src="../../assets/img_h5/组 32@2x.png" />
						</div>
					</div>
				</div>
				<div class="btn_box_f"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div v-if="isWqAll" class="btn_box_ty btn_box" @click="WqLoadAll">
						Load More
					</div>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import { resourcesList } from '@/api/public_h5';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			jqNewsData: [],
			wqNewsData: [],
			jqStatus: '',
			jqLoading: false,
			isJqAll: true,
			wqLoading: false,
			isWqAll: true,
			jqNewsLoading: true,
			wqNewsLoading: true,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		//请求近期新闻
		that.getJqData(6);
		//请求往期新闻
		that.getWqData(6);
	},
	watch: {
		//
	},
	methods: {
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			// that.$router.push({ path: '/resources-info', query: { id: value.unionid, } });
			that.$router.push({ name: 'Resourcesinfo', params: { resourcesInfoId: value.custom, } });
		},
		//新闻状态切换
		isClickHandle(value) {
			let that = this;
			that.jqStatus = value;
			that.getJqData(99999999);
			that.isJqAll = true;
		},
		//往期翻页
		WqLoadAll() {
			let that = this;
			that.getWqData(99999999);
			that.isWqAll = false;
		},
		//近期翻页
		jqLoadAll() {
			let that = this;
			that.getJqData(99999999);
			that.isJqAll = false;
		},
		//请求往期新闻
		getWqData(limit) {
			let that = this;
			that.wqNewsLoading = true;
			resourcesList({
				catid: 2,
				is_tuijian: '',
				page: 1,
				page_size: limit,
				language: sessionStorage.getItem('lang'),
			}).then(res2 => {
				that.wqNewsData = res2.data.data;
				that.isLoading = false;
				that.wqNewsLoading = false;
			});
		},
		//请求近期新闻
		getJqData(limit) {
			let that = this;
			that.jqNewsLoading = true;
			resourcesList({
				catid: 1,
				is_tuijian: that.jqStatus,
				page: 1,
				page_size: limit,
				language: sessionStorage.getItem('lang'),
			}).then(res2 => {
				that.jqNewsData = res2.data.data;
				that.isLoading = false;
				that.jqNewsLoading = false;
			});
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块2*/
	.list_box{
		padding: 42px 20px;
		.btn_box{
			margin: 16px 0;
		}
		.list_box_2{
			.list_el{
				margin-bottom: 20px;
				display: flex;
				align-items: center;
				border-bottom: 1px solid #999999;
				.left{
					flex: 1;
					padding-right: 20px;
					.tit{
						padding-bottom: 18px;
						font-size: 22px;
					}
					.time{
						padding-bottom: 10px;
						color: #706B69;
						font-size: 18px;
					}
				}
				.right{
					width: 20px;
					img{ width: 100%; }
				}
			}
		}
		.list_box_1{
			.list_el{
				margin-bottom: 42px;
				padding-bottom: 25px;
				background-color: #FFFFFF;
				box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
				.txt_box{
					padding: 20px;
					.time{
						padding-top: 30px;
						font-size: 18px;
						color: #706B69;
					}
					.tit{
						font-size: 22px;
					}
				}
				img.bg{
					width: 100%;
					// height: 250px;
					object-fit: cover;
				}
			}
		}
		.tags{
			padding: 16px 0 34px 0;
			div{
				display: inline-block;
				margin-right: 20px;
				background: #FFFFFF;
				border-radius:21px;
				border: 1px solid #eaeaea;
				font-size: 20px;
				color: #0B318F;
				padding: 6px 20px 4px 20px;
				cursor: pointer;
			}
			div.actived{
				background-color: #F5F8FA;
				border: 1px solid #0B318F;
			}
		}
		.title{
			font-size: 36px;
		}
	}
	/*块1*/
	.block_1{
		padding: 22px 0 0 0;
		color: #3D3D3D;
		.bg_box{
			padding-bottom: 42px;
			img{ width: 100%; }
		}
		.txt{
			padding: 0 20px 30px 20px;
			font-size: 20px;
		}
		.tit{
			text-align: center;
			padding: 0 20px;
			font-size: 42px;
		}
	}
}
</style>
